import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface ResendEmailParams {
  emailId: string;
  templateKey: string;
  toEmail: string;
  userId: string | null;
  variables: Record<string, string>;
}

export function useResendScheduledEmail() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ templateKey, toEmail, userId, variables }: ResendEmailParams) => {
      // Call the send-transactional-email edge function directly
      const { data, error } = await supabase.functions.invoke('send-transactional-email', {
        body: {
          templateKey,
          toEmail,
          userId,
          variables,
        },
      });

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      toast.success('Email reenviado com sucesso!');
      queryClient.invalidateQueries({ queryKey: ['scheduled-emails'] });
      queryClient.invalidateQueries({ queryKey: ['email-logs'] });
    },
    onError: (error: Error) => {
      toast.error(`Erro ao reenviar email: ${error.message}`);
    },
  });
}

export function useUpdateScheduledEmailVariables() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ emailId, variables }: { emailId: string; variables: Record<string, string> }) => {
      const { error } = await supabase
        .from('scheduled_emails')
        .update({ variables })
        .eq('id', emailId);

      if (error) throw error;
    },
    onSuccess: () => {
      toast.success('Variáveis atualizadas!');
      queryClient.invalidateQueries({ queryKey: ['scheduled-emails'] });
    },
    onError: (error: Error) => {
      toast.error(`Erro ao atualizar variáveis: ${error.message}`);
    },
  });
}
